"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
/**
 * @hidden
 */
var Header;
(function (Header) {
    Header["AUTHORIZATION"] = "Authorization";
    Header["API_TOKEN"] = "API-Token";
    Header["COMPANY_NAME_KEY"] = "company-name-key";
    Header["CONTENT_TYPE"] = "Content-Type";
    Header["SUBDOMAIN"] = "subdomain";
})(Header = exports.Header || (exports.Header = {}));
//# sourceMappingURL=base.js.map